import { NotifyHelper } from "../../../helpers/toast";
import { eXepLoaiHocTapActionsObj } from "../../action-types/category/IXepLoaiHocTapActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const xepLoaiHocTapActions = {
    ...generateActions(eXepLoaiHocTapActionsObj, "XEP_LOAI_HOC_TAP"),
    ...generateActionForKey(eXepLoaiHocTapActionsObj, "XEP_LOAI_HOC_TAP", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eXepLoaiHocTapActionsObj, "XEP_LOAI_HOC_TAP", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eXepLoaiHocTapActionsObj, "XEP_LOAI_HOC_TAP", "SAVE_ERROR", (m) => { NotifyHelper.Success(m) }),
    ...generateActionForKey(eXepLoaiHocTapActionsObj, "XEP_LOAI_HOC_TAP", "DELETE_ERROR", (m) => { NotifyHelper.Success(m) }),
}